import React from 'react';
import { Avatar, Typography, Descriptions } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import './StaffForm.less';

const { Title, Text, Paragraph } = Typography;

class StaffForm extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { fields = {} } = this.props;
    const {
      store_name,
      avatar,
      user_name,
      age,
      education,
      placeOfOrigin,
      position_name,
      level,
      experience,
      advantages,
      nanny_Introduction,
      work,
      certificates_list
    } = fields;

    // 解析证书列表 JSON 字符串
    let parsedCertificates = [];
    if (certificates_list) {
      try {
        if (typeof certificates_list === 'string') {
          parsedCertificates = JSON.parse(certificates_list);
        } else if (Array.isArray(certificates_list)) {
          parsedCertificates = certificates_list;
        }
      } catch (error) {
        console.error('解析证书列表失败:', error);
        parsedCertificates = [];
      }
    }

    return (
      <div className="staff-form-container">{/* 顶部标题 */}{/* 左侧头像区域 */}
        <div className="staff-avatar-section">
            <Avatar
            size={120}
            src={avatar}
            icon={!avatar ? <UserOutlined /> : undefined}
            className="staff-avatar"
            />
        </div>
        <div className="staff-form-header">
            <Title level={4} className="store-title">{store_name}</Title>
        </div>
        <div className="staff-form-wrapper">
          

          {/* 主要内容区域 */}
          <div className="staff-form-content">
          

          {/* 右侧信息区域 */}
          <div className="staff-info-section">
            <Descriptions 
              column={4} 
              bordered={false}
              className="staff-basic-info"
              labelStyle={{ color: '#666' }}
              contentStyle={{ color: '#333' }}
            >
              <Descriptions.Item label="姓名">{user_name}</Descriptions.Item>
              <Descriptions.Item label="年龄">{age}{age ? '岁' : ''}</Descriptions.Item>
              <Descriptions.Item label="学历">{education}</Descriptions.Item>
              <Descriptions.Item label="籍贯">{placeOfOrigin}</Descriptions.Item>
              <Descriptions.Item label="职位">{position_name}</Descriptions.Item>
              <Descriptions.Item label="等级">{level}</Descriptions.Item>
              <Descriptions.Item label="经验">{experience}{experience ? '年' : ''}</Descriptions.Item>
              </Descriptions>
              <Descriptions
                column={1}
                labelStyle={{ color: '#666' }}
                contentStyle={{ color: '#333' }}
              >
              <Descriptions.Item label="优势">
                <Typography.Text className="advantages-text">{advantages}</Typography.Text>
              </Descriptions.Item>
            </Descriptions>
          </div>
          </div>

          {/* 个人简介 */}
          {nanny_Introduction && (
            <div className="staff-section">
              <div className="section-label-wrapper">
                <div className="section-label-icon">
                  <div className="label-char">个</div>
                  <div className="label-char">人</div>
                  <div className="label-char">简</div>
                  <div className="label-char">介</div>
                </div>
              </div>
              <Typography>
                <Paragraph className="intro-text">{nanny_Introduction}</Paragraph>
              </Typography>
            </div>
          )}
          {/* 工作经验 */}
          {work && (
            <div className="staff-section">
                <div className="section-label-wrapper">
                <div className="section-label-icon">
                  <div className="label-char">工</div>
                  <div className="label-char">作</div>
                  <div className="label-char">经</div>
                  <div className="label-char">验</div>
                </div>
              </div>
              <Typography>
                <Paragraph className="experience-text">{work}</Paragraph>
              </Typography>
            </div>
          )}
        </div>
        {/* 证书部分 */}
        {parsedCertificates && Array.isArray(parsedCertificates) && parsedCertificates.length > 0 && (
            <div className="staff-certificates">
              {parsedCertificates.map((certificate, index) => (
                <div key={index} className="certificate-item">
                  <img
                    src={certificate.url}
                    alt={certificate.name || '证书'}
                    className="certificate-image"
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                  <Typography.Text strong className="certificate-title">{certificate.name || '证书'}</Typography.Text>
                </div>
              ))}
            </div>
          )}
      </div>
    );
  }
}

export default StaffForm;

